var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"menu-section user-select-none"},[_c('h4',{staticClass:"menu-text"},[(_vm.icon)?_c('i',{staticClass:"mr-2",class:_vm.icon}):_vm._e(),_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }